import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

interface SavFilterState {
  selectedManagerFilter: string; // 'all', 'my-savs', 'unassigned', or manager UUID
  setSelectedManagerFilter: (filter: string) => void;
  getManagerFilterParam: () => string | undefined;
}

export const useSavFilterStore = create<SavFilterState>()(
  devtools(
    persist(
      (set, get) => ({
        selectedManagerFilter: 'all',
        setSelectedManagerFilter: (filter: string) => set({ selectedManagerFilter: filter }),
        getManagerFilterParam: () => {
          const filter = get().selectedManagerFilter;
          // 'all' means no filter
          if (filter === 'all') return undefined;
          // Return the filter value directly for 'my-savs', 'unassigned', or UUID
          return filter;
        },
      }),
      {
        name: 'sav-filter-storage-v2',
        version: 1,
        // Migration: convert old boolean to new string format
        migrate: (persistedState: any) => {
          // Handle old format with showOnlyMySavs boolean
          if (persistedState && typeof persistedState.showOnlyMySavs === 'boolean') {
            return {
              selectedManagerFilter: persistedState.showOnlyMySavs ? 'my-savs' : 'all',
            };
          }
          return persistedState;
        },
      }
    ),
    { name: 'SavFilterStore' }
  )
);
